import React from 'react';
import { Menu } from 'react-data-grid-addons';

const { MenuItem, SubMenu } = Menu;

export default function AddColumnMenu({ columns, currentColumns, onAdd }) {
	const hiddenColumns = columns
		.map((column, index) => ({ column, index }))
		.filter(({ column }) => !currentColumns.some(current => current.key === column.key));

	if (hiddenColumns.length === 0) return null;

	return (
		<SubMenu title="Add Column">
			{hiddenColumns.map(({ column, index }) =>
				<MenuItem key={column.key} onClick={() => onAdd(index)}>{column.addLabel || column.name}</MenuItem>)}
		</SubMenu>
	);
}